// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Gq-z","slideIn":"Hq-z"};